import { render, staticRenderFns } from "./scan_match.vue?vue&type=template&id=570690ae&scoped=true"
import script from "./scan_match.vue?vue&type=script&lang=js"
export * from "./scan_match.vue?vue&type=script&lang=js"
import style0 from "./scan_match.vue?vue&type=style&index=0&id=570690ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570690ae",
  null
  
)

export default component.exports